// 결제내역(통합) 화면의 요청 파라미터 생성 순수 함수 모음
// (SPEC-RESELLER-PAYMENT-ADMIN-001). axios·별칭 import 없이 node:test 로 검증한다.

// @MX:NOTE: [AUTO] inapi DTO 의 RESELLER_PAYMENT_HISTORY_MAX_LIMIT 과 같은 값을 유지한다.
// 초과 시 엑셀을 저장하지 않는다(잘라서 저장 금지).
export const PAYMENT_HISTORY_EXPORT_MAX = 10000;

const SORTABLE_COLUMNS = ["paidAt", "createdAt", "amount"];

const isBlank = (v) => v === undefined || v === null || v === "";

// 빈 값(빈 문자열·null·undefined)을 제거한다
const compact = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => !isBlank(v)));

// 목록·통계가 공유하는 조건 (상태 제외). 상품명 입력값은 productName 으로 보낸다.
const buildFilterParams = (form) =>
  compact({
    resellerId: form.resellerId,
    dateType: form.dateType,
    startDate: form.startDate,
    endDate: form.endDate,
    companyName: form.companyName,
    productName: form.packageName,
  });

/**
 * 목록 요청 본문.
 * dateType 은 항상 포함한다(서버 기본값이 createdAt 이라 화면 기본 결제일 기준을 지키려면 필요).
 */
export const buildPaymentHistoryListParams = (form, { page, limit, sort }) => ({
  page,
  limit,
  sortBy: sort.sortBy,
  sortOrder: sort.sortOrder,
  ...buildFilterParams(form),
  ...compact({ status: form.status }),
});

/** 통계 쿼리: 목록 조건에서 상태·페이지·정렬을 뺀 것 (D8) */
export const buildPaymentHistoryStatsParams = (form) => buildFilterParams(form);

/**
 * antd table sorter → { sortBy, sortOrder }.
 * 해제되었거나 허용 목록 밖 열이면 기간 기준 필드 내림차순.
 */
export const resolveSort = (sorter, dateType) => {
  const columnKey = sorter && sorter.columnKey;
  const order = sorter && sorter.order;
  if (!SORTABLE_COLUMNS.includes(columnKey) || !order) {
    return { sortBy: dateType, sortOrder: "desc" };
  }
  return { sortBy: columnKey, sortOrder: order === "ascend" ? "asc" : "desc" };
};

/**
 * 기간 기준 변경 시 정렬 규칙 (S6).
 * 관리자가 고른 금액 정렬은 유지, 그 외에는 새 기준 필드 내림차순.
 */
export const nextSortOnDateTypeChange = (currentSort, newDateType) =>
  currentSort.sortBy === "amount"
    ? currentSort
    : { sortBy: newDateType, sortOrder: "desc" };
